// Port of api/fuel/app/classes/model/buddies.php
import Model from 'offline/stream/model/base'
import F from 'offline/filter/constants'

export default Model.extend({
	table: 'buddies',
	prefix: 'buddies',
	key: 'buddies_id',
	fields: {
		buddies_id: Model.SCHEMA_NUMBER,
		user_id: Model.SCHEMA_NUMBER,
		buddies_name: Model.SCHEMA_TEXT,
		buddies_slug: Model.SCHEMA_TEXT,
		buddies_avatar: Model.SCHEMA_TEXT,
		buddies_date_created: Model.SCHEMA_DATE_CREATE,
		buddies_date_sync: Model.SCHEMA_DATE,
		buddies_date_play_first: Model.SCHEMA_DATE,
		buddies_count_users: Model.SCHEMA_NUMBER,
		buddies_count_sync: Model.SCHEMA_NUMBER,
		buddies_count_collection: Model.SCHEMA_NUMBER,
		buddies_count_collection_games: Model.SCHEMA_NUMBER,
		buddies_count_collection_expansions: Model.SCHEMA_NUMBER,
		buddies_count_ratings: Model.SCHEMA_NUMBER,
		buddies_count_plays: Model.SCHEMA_NUMBER,
		buddies_count_plays_games: Model.SCHEMA_NUMBER,
		buddies_count_lists: Model.SCHEMA_NUMBER,
		buddies_data_queue: Model.SCHEMA_NUMBER,
		buddies_data_version: Model.SCHEMA_NUMBER
	},
	methods: {
		get_type_constant: function() { return F.OWNER_BUDDIES },
		get_data_version: function() { return this._data.buddies_data_version || 0 },
		get_user_id: function() { return this._data.user_id },
		has_synchronised: function() {
			return (this.get_count_users() || 0) === (this.get_count_sync() || 0) && (this.get_count_users() || 0) > 0
		},
		get_threshold: function() {
			var count = this.get_count_users() || 0
			if (count <= 1) return 1
			if (count <= 4) return 2
			if (count <= 6) return 3
			if (count <= 10) return 4
			if (count <= 20) return 5
			if (count <= 30) return 6
			if (count <= 40) return 7
			if (count <= 50) return 8
			if (count <= 60) return 9
			return 10
		},
		to_array: function() {
			return {
				id: this.get_id(),
				name: this.get_name(),
				slug: this.get_slug(),
				avatar: this.get_avatar(),
				threshold: this.get_threshold(),
				date: { sync: false, firstPlay: this.get_date_play_first() || 0 },
				queueSync: this.get_data_queue() || 0,
				count: {
					collection: this.get_count_collection() || 0,
					ratings: this.get_count_ratings() || 0,
					users: this.get_count_users() || 0,
					plays: this.get_count_plays() || 0,
					lists: this.get_count_lists() || 0,
					sync: 0
				},
				requireSync: !this.has_synchronised()
			}
		}
	}
})
